module.exports = __webpack_public_path__ + "img/hourglass.278562a3.svg";